import React, { PureComponent } from 'react';
import moment from 'moment';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';

import { DATE_FORMAT } from '../../app/config/config';
import { Table, Breadcrumb } from '../../common/components';
import { getBreakdowns } from '../../breakdown/services/breakdown.service';
import CompanyTabsComponent from './companyTabs.container';

const TABLE_CONFIG = {
  columns: [
    {
      caption: 'Data',
      dataField: 'createdAt',
      sort: true,
      renderCell: (createdAt) => moment(createdAt).format(DATE_FORMAT),
    },
    {
      caption: 'VIN',
      dataField: 'car.vin',
      sort: true,
    },
    {
      caption: 'Marka',
      dataField: 'car.manufacturer.name',
    },
    {
      caption: 'Model',
      dataField: 'car.model.name',
    },
    {
      caption: 'Grupa awarii',
      dataField: 'type.name',
    },
    {
      caption: 'Cena naprawy',
      dataField: 'price',
      renderCell: (price) => (price > 0 ? parseInt(price, 0) : '-'),
    },
  ],
  idProperty: 'car.id',
  noItemsFoundText: 'Brak awarii',
  initialSort: {
    sortField: 'createdAt',
    sortDirection: 'desc',
  },
  filterFields: 'car.vin',
};

class CompanyDetailsBreakdowns extends PureComponent {
  state = {
    data: [],
    totalCount: 0,
    isLoading: true,
  };

  id = this.props.match.params.id;

  get = async (params) => {
    this.setState({
      isLoading: true,
    });

    const { data, totalCount } = await getBreakdowns(
      Object.assign(params, { company: this.id }),
    );

    this.setState({
      data,
      totalCount,
      isLoading: false,
    });
  };

  onRowClick = (ev) => {
    const {
      currentTarget: { id },
    } = ev;
    const { history } = this.props;

    history.push(`/car-details/${id}`);
  };

  render() {
    const { data, isLoading, totalCount } = this.state;

    return (
      <>
        <Breadcrumb title="Lista awarii"></Breadcrumb>
        <div className="content">
          <CompanyTabsComponent active="breakdowns" />
          <Table
            config={TABLE_CONFIG}
            items={data}
            fetchData={this.get}
            totalCount={totalCount}
            isLoading={isLoading}
            onRowClick={this.onRowClick}
            pagination
          />
        </div>
      </>
    );
  }
}

CompanyDetailsBreakdowns.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default withRouter(CompanyDetailsBreakdowns);
